module.exports = __webpack_public_path__ + "907626321cceff597a550f37eaca2ecb.svg";


//////////////////
// WEBPACK FOOTER
// ./process/assets/l_down_arrow.svg
// module id = 148
// module chunks = 0